function configSelecao() {
	var salva_selecao_throttle = 1000;
	var salva_selecao_called = false;

	function merge_selecao(modulo) {
		var selecao = {};

		$('.js-selecao-sessao-checkbox').each(function() {
			var checked = $(this).prop('checked');
			var modulo  = $(this).attr('modulo');
			var item_id = $(this).val();

			if(checked) {
				selecao[item_id] = 1;
			} else {
				selecao[item_id] = 0;
			}
		});

		$.post(baseurl+"admin/"+modulo+"/ajax_selecao_merge"
			, {'selecao': selecao}
		);
	}

	function verificar_habilitacao(esperados, situacoes) {
		if (esperados.some(r=> situacoes.includes(r))) {
			return false
		} else {
			return true
		}
	}

	function ativar_lista_acoes(situacoes) {
		if (!situacoes) situacoes = [];

		verificar_habilitacao(['reajustar'], situacoes)?$(".js-selecao-acao-contrato_reajustar").hide():$(".js-selecao-acao-contrato_reajustar").show()
		verificar_habilitacao(['vencido'], situacoes)?$(".js-selecao-acao-contrato_renovar").hide():$(".js-selecao-acao-contrato_renovar").show()
		verificar_habilitacao(['emandamento','reajustar','prazoindeterminado'], situacoes)?$(".js-selecao-acao-contrato_encerrar").hide():$(".js-selecao-acao-contrato_encerrar").show()
		verificar_habilitacao(['emandamento','reajustar','prazoindeterminado'], situacoes)?$(".js-selecao-acao-contrato_inativar").hide():$(".js-selecao-acao-contrato_inativar").show()
		verificar_habilitacao(['emandamento','reajustar','prazoindeterminado'], situacoes)?$(".js-selecao-acao-contrato_rescindir").hide():$(".js-selecao-acao-contrato_rescindir").show()
		verificar_habilitacao(['emandamento','reajustar','encerrado','rescindido','juridico','acaodedespejo','prazoindeterminado','pendente'], situacoes)?$(".js-selecao-acao-contrato_excluir").hide():$(".js-selecao-acao-contrato_excluir").show()
		verificar_habilitacao(['encerrado','rescindido','juridico','acaodedespejo','pendente'], situacoes)?$(".js-selecao-acao-contrato_reativar").hide():$(".js-selecao-acao-contrato_reativar").show()
		verificar_habilitacao(['emandamento','reajustar','prazoindeterminado'], situacoes)?$(".js-selecao-acao-contrato_acao_de_despejo").hide():$(".js-selecao-acao-contrato_acao_de_despejo").show()
		verificar_habilitacao(['reajustar'], situacoes)?$(".js-selecao-acao-contrato_suspender").hide():$(".js-selecao-acao-contrato_suspender").show()

	}

	$('.js-selecao-sessao-checkbox').click(function(e) {
		var checked = $(this).prop('checked');
		var modulo  = $(this).attr('modulo');
		var item_id = $(this).val();

		$.post(baseurl+"admin/"+modulo+"/ajax_selecao"
			, {'checked': checked, 'item_id': item_id}
		).done(function(data){
			
			if (data) {
				$('.js-selecao-acao-contrato').prop('disabled', 'disabled');
				$('.mensagem_erro_contrato_situacoes_diferentes').show();
			} else {
				$('.js-selecao-acao-contrato').prop('disabled', false);
				$('.mensagem_erro_contrato_situacoes_diferentes').hide();
			}
			$.post(baseurl+"admin/"+modulo+"/ajax_contratos_selecionados_lista_situacoes")
				.done(function(data){
					ativar_lista_acoes(data);
				});
		});
	});

	$('.js-selecao-sessao-selecionar-pagina').click(function(e) {
		$('.js-selecao-sessao-checkbox').prop('checked', true);
		var modulo  = $('.js-selecao-sessao-checkbox').attr('modulo');

		merge_selecao(modulo);

		e.preventDefault();
	});

	$('.js-selecao-sessao-desselecionar-pagina').click(function(e) {
		$('.js-selecao-sessao-checkbox').prop('checked', false);
		var modulo  = $('.js-selecao-sessao-checkbox').attr('modulo');

		merge_selecao(modulo);

		e.preventDefault();
	});

	$('.js-selecao-sessao-limpar').click(function(e) {
		var modulo  = $(this).attr('modulo');
		$.post(baseurl+"admin/"+modulo+"/ajax_selecao_limpar");

		$('.js-selecao-sessao-checkbox').prop('checked', false);
		$('.js-selecao-acao-contrato').prop('disabled', false);
		e.preventDefault();
	});

	// seleção sem sessão

	$('.js-selecao-checkbox').click(function(e) {
		var checked = $(this).prop('checked');
		var item_id = $(this).val();
	});

	$('.js-selecao-selecionar-pagina').click(function(e) {
		$('.js-selecao-checkbox').prop('checked', true);
		e.preventDefault();
	});

	$('.js-selecao-desselecionar-pagina').click(function(e) {
		$('.js-selecao-checkbox').prop('checked', false);
		e.preventDefault();
	});

	// ações em massa

	$('.js-selecao-publicar').click(function(e) {
		var funcao = 'imagens_publicar_lote';
		var userfuncao = $(this).attr('data-funcao');
		if(userfuncao != undefined) {
			funcao = userfuncao;
		}

		var selecarray = [];
		var selecionados  = $('input[name="selecionados[]"]:checked');

		selecionados.each(function() {
			selecarray.push($(this).val());
		});

		$.post(baseurlc+funcao,{'selecionados':selecarray},function(data) {
			selecionados.each(function() {
				var id = $(this).val();
				$('#ativo'+id).prop('checked', true);
			});

			selecionados.prop('checked',false);
			selecionados.change();
		});

		e.preventDefault();
	});

	$('.js-selecao-despublicar').click(function(e) {
		var funcao = 'imagens_despublicar_lote';
		var userfuncao = $(this).attr('data-funcao');
		if(userfuncao != undefined) {
			funcao = userfuncao;
		}

		var selecarray = [];
		var selecionados  = $('input[name="selecionados[]"]:checked');

		selecionados.each(function() {
			selecarray.push($(this).val());
		});

		$.post(baseurlc+funcao,{'selecionados':selecarray},function(data) {
			selecionados.each(function() {
				var id = $(this).val();
				$('#ativo'+id).prop('checked', false);
			});

			selecionados.prop('checked',false);
			selecionados.change();
		});

		e.preventDefault();
	});

	$('.js-selecao-excluir').click(function(e) {
		if(!confirm('Confirma a exclusão dos itens selecionados?')) {
			e.preventDefault();
			return false;
		}

		var funcao = 'excluir_varios';
		var userfuncao = $(this).attr('data-funcao');
		if(userfuncao != undefined) {
			funcao = userfuncao;
		}

		var selecarray = [];
		var selecionados  = $('input[name="selecionados[]"]:checked');

		selecionados.each(function() {
			selecarray.push($(this).val());
		});

		$.post(baseurlc+funcao,{'selecionados':selecarray},function(data) {
			selecionados.each(function() {
				var parent = $(this).attr('data-parent');
				var $parent = $(parent);

				if($(this).prop('checked')) {
					$parent.fadeOut();
				}
			});

			selecionados.prop('checked',false);
		});

		e.preventDefault();
	});

	$('.js-selecao-acao-contrato').change(function(e) {
		var selecionado = $(this).val();

	});

	$( document ).ready(function() {
		if ($('.js-selecao-acao-contrato').length) {
			var modulo  = $('.js-selecao-sessao-checkbox').attr('modulo');
			$.post(baseurl+"admin/"+modulo+"/ajax_contratos_situacoes_diferentes")
				.done(function($data){
					if ($data) {
						$('.js-selecao-acao-contrato').prop('disabled', 'disabled');
					} else {
						$('.js-selecao-acao-contrato').prop('disabled', false);
					}
				});
			$.post(baseurl+"admin/"+modulo+"/ajax_contratos_selecionados_lista_situacoes")
				.done(function(data){
					ativar_lista_acoes(data);
				});
		}
	});

}

export default configSelecao;
